import {
  Box,
  Flex,
  Text,
  Button,
  FormControl,
  Input,
  TabList,
  Tab,
} from "@chakra-ui/react";
import { chakra } from "@chakra-ui/react";

export const StyledContainer = chakra(Box, {
  baseStyle: {
    bg: "red",
    color: "black",
    width: "100%",
  },
});

export const StyledTabsContainer = chakra(Box, {
  baseStyle: {
    w: "full",
    p: 4,
    pt: 0,
  },
});

export const StyledTabList = chakra(TabList, {
  baseStyle: {
    p: 4,
    display: "flex",
    borderBottom: "1px solid",
    borderColor: "gray.200",
  },
});

export const StyledTab = chakra(Tab, {
  baseStyle: {
    _selected: {
      bg: "blue.100",
      color: "blue.500",
      borderRadius: "8px",
      padding: "16px",
    },
    color: "gray.500",
    // Set height
    // Set padding
  },
});

export const StyledProfileContainer = chakra(Box, {
  baseStyle: {
    w: "full",
    maxW: "800px",
    p: { base: 2, sm: 4 },
    rounded: "md",
  },
});

export const StyledSectionTitle = chakra(Text, {
  baseStyle: {
    fontSize: "20px",
    fontWeight: "500",
    mb: 4,
    color: "#18191B",
  },
});

export const StyledSectionDescription = chakra(Text, {
  baseStyle: {
    mb: 6,
    color: "gray.500",
    fontWeight: "400",
    fontSize: "16px",
  },
});

export const StyledAvatarBox = chakra(Box, {
  baseStyle: {
    mb: 6,
    p: 4,
    bg: "theme.bg.box",
    border: "1px",
    borderColor: "theme.gray.100",
    rounded: "md",
    _dark: {
      borderColor: "theme.gray.200",
    },
  },
});

export const StyledAvatarTitle = chakra(Text, {
  baseStyle: {
    fontSize: "md",
    fontWeight: "bold",
    mb: 4,
  },
});

export const StyledAvatarContainer = chakra(Flex, {
  baseStyle: {
    direction: "column",
    flexWrap:'wrap',
    align: "center",
    mb: 4,
    gap: "24px",
  },
});

export const StyledUserInfoBox = chakra(Box, {
  baseStyle: {
    p: 4,
    bg: "theme.bg.box",
    rounded: "md",
    border: "1px",
    borderColor: "theme.gray.100",
    _dark: {
      borderColor: "theme.gray.200",
    },
  },
});

export const StyledUserInfoHeader = chakra(Flex, {
  baseStyle: {
    justify: "space-between",
    mb: 4,
    display: "flex",
  },
});

export const StyledFormControl = chakra(FormControl, {
  baseStyle: {
    mb: 4,
  },
});

export const StyledInput = chakra(Input, {
  baseStyle: {
    bg: "white",
    borderColor: "theme.gray.border",
    _hover: { borderColor: "gray.400" },
    _focus: { borderColor: "gray.400" },
    _dark: { borderColor: "theme.gray.200" },
  },
});

export const StyledSubmitButton = chakra(Button, {
  baseStyle: {
    bgColor: "theme.button.primary",
  },
});

export const StyledButton = chakra(Button, {
  baseStyle: {
    borderRadius: "8px",
    border: "1px solid",
    padding: "12px",
    display: "flex",
    color: "#1782FF",
    alignItems: "center",
    justifyContent: "center",
    bg: "transparent",
  },
});
export const StyledDeleteButton = chakra(Button, {
  baseStyle: {
    borderRadius: "8px",
    border: "1px solid",
    padding: "8px",
    gap: "16px",
    color: "red",
    bg: "transparent",
  },
});
